import React, { useEffect } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrinters, getPrint } from '../../app/reducers/Print/printSlice';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { ClipLoader } from 'react-spinners';

const TriggerPrinterSelectModal = ({
    showPrinterSelectModal,
    setShowPrinterSelectModal,
    printerDataId,
    setPrinterDataId,
    payload,
    triggerAutomation,
}) => {
    const { printers, loading } = useSelector(getPrint);
    const dispatch = useDispatch();

    useEffect(() => {
        setPrinterDataId(
            printers.map((ele) => ({
                label: `${ele.computer.name}/${ele.name}`,
                value: ele.id,
            }))[0]
        );
    }, [JSON.stringify(printers)]);

    return (
        <ModalBasic
            modalOpen={showPrinterSelectModal}
            setModalOpen={setShowPrinterSelectModal}
            title={'Select Printer For Trigger Automation'}
        >
            {loading ? (<ClipLoader />) :<div
                className="p-4 h-[400px] flex flex-col gap-4"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div>
                    <label>Select Printer</label>
                    <Select
                        options={printers.map((ele) => ({
                            label: `${ele.computer.name}/${ele.name}`,
                            value: ele.id,
                        }))}
                        value={printerDataId}
                        onChange={(selectedOption) => {                            
                            setPrinterDataId(selectedOption);
                        }}
                    />
                </div>
                <div>
                    <PrimaryButton
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerAutomation({
                                ...payload,
                                printerId: printerDataId.value,
                            });
                            setShowPrinterSelectModal(false);
                            setPrinterDataId(
                                printers.map((ele) => ({
                                    label: `${ele.computer.name}/${ele.name}`,
                                    value: ele.id,
                                }))[0]
                            );
                        }}
                    >
                        Print
                    </PrimaryButton>
                </div>
            </div>}
        </ModalBasic>
    );
};

export default TriggerPrinterSelectModal;
